var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    style: {
      enableBackground: "new 0 0 12 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:none;stroke:#217345;}\r\n\t.st2{fill:#217345;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-excel",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_59",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 12,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 13
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_35",
    className: "st2",
    d: "M5.6,4.6H3.9L5.9,8l-2.1,3.5h1.7L7,9l1.5,2.5h1.7L8,8l2.1-3.4H8.4L7,7.1L5.6,4.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcel);
export default __webpack_public_path__ + "static/media/icon-excel.7dd911e00a556b52de2ec9559eaec52f.svg";
export { ForwardRef as ReactComponent };